import { useCallback, useState } from "react";
import { fetchGoogleConnectUrl } from "../api/auth";

// Connecting the firm Google account is admin-only, so the flow cannot be a
// plain link: we ask the server for the consent URL with the Authorization
// header and then navigate. Shared by the inbox card and the connections
// panel, which both offer the same button.
export interface GoogleConnect {
  connect: () => void;
  connecting: boolean;
  error: string | null;
}

export function useGoogleConnect(): GoogleConnect {
  const [connecting, setConnecting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const connect = useCallback(() => {
    setConnecting(true);
    setError(null);
    fetchGoogleConnectUrl()
      .then((r) => {
        if (r.ok) {
          window.location.assign(r.url);
          return;
        }
        setConnecting(false);
        setError(
          r.status === 403
            ? "Only an admin can connect the firm Google account"
            : `Could not start the Google flow (HTTP ${r.status})`,
        );
      })
      .catch(() => {
        setConnecting(false);
        setError("Server not reachable");
      });
  }, []);

  return { connect, connecting, error };
}
